import EmptyDevices from './EmptyDevices';

export default EmptyDevices;
